/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Lefoeprowoche3Inputs */

const de__field_lefoeprowoche3 = /** @type {(inputs: _Field_Lefoeprowoche3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lerförderungen pro Woche`)
};

/**

* @param {_Field_Lefoeprowoche3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_lefoeprowoche3 = /** @type {((inputs?: _Field_Lefoeprowoche3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Lefoeprowoche3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_lefoeprowoche3(inputs)
});
export { _field_lefoeprowoche3 as "_field_leFoeProWoche" }